<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { AuthModel } from "@/modules/core/auth/services/AuthService";

@Options({})
export default class PushNotifications extends Vue
{
    public get userIdentity(): AuthModel
    {
        return this.$store.state.auth.identity;
    }

    public get subscribedPlayerId(): string
    {
        return this.$store.state.auth.subscribedPlayerId || null;
    }

    public async setExternalUserId(): Promise<void>
    {
        await this.$OneSignal.login(this.userIdentity.publicId);
    }

    public async mounted(): Promise<void>
    {
        if (this.userIdentity && this.$OneSignal)
        {
            const notifications = this.$OneSignal.Notifications;

            // Push is optional: mobile browsers (e.g. iOS Safari outside an installed PWA) don't support it,
            // and that must not surface an error or block the rest of the UI (notifications, chat).
            if (!notifications.isPushSupported())
            {
                console.warn('[OneSignal] Push notifications are not supported in this browser');

                return;
            }

            if (!notifications.permission)
            {
                // Mobile browsers ignore permission prompts that aren't triggered by a user gesture,
                // so ask on the first interaction instead of on mount.
                const ask = async (): Promise<void> =>
                {
                    try
                    {
                        await notifications.requestPermission();
                        await this.$OneSignal.login(this.userIdentity.publicId);
                    }
                    catch (e)
                    {
                        console.error('[OneSignal] requestPermission failed:', e);
                    }
                };

                if (typeof Notification !== 'undefined' && Notification.permission === 'denied')
                    return;

                document.addEventListener('click', ask, { once: true });

                return;
            }

            let attepmts = 0;

            const interval = setInterval(async () =>
            {
                if (attepmts === 4)
                    clearInterval(interval);

                await this.$OneSignal.login(this.userIdentity.publicId);
                attepmts++;
            }, 500);
        }
    }

}
</script>
